import { breakpoints } from "../styles/breakpoints";
import { useMediaQuery } from "./useMediaQuery";

const useIsMobile = () => {
  const mobileBreakpoint = breakpoints[5];

  return useMediaQuery(`(max-width: ${mobileBreakpoint})`);
};

export default useIsMobile;
